import {
	ExamBookingEnum,
	HealthBookingEnum,
	OdontoBookingEnum,
	RequestSchedule,
	TelehealthBookingEnum,
} from 'presentation/constants';

const IS_BOOKING_FLOW_PATHS = [
	HealthBookingEnum.HEALTH_BOOKING_FLOW,
	TelehealthBookingEnum.TELEHEALTH_BOOKING_FLOW,
	OdontoBookingEnum.ODONTO_BOOKING_FLOW,
	ExamBookingEnum.EXAM_BOOKING_FLOW,
	RequestSchedule.REQUEST,
];

const ICON_LOGO_HEIGHT = 48;

export {ICON_LOGO_HEIGHT, IS_BOOKING_FLOW_PATHS};
